import Navbar from "@/components/Navbar";
import Seo from "@/components/Seo";
import HomeHero from "@/components/home/HomeHero";
import HomeStats from "@/components/home/HomeStats";
import AnyaStory from "@/components/home/AnyaStory";
import HowItWorks from "@/components/home/HowItWorks";
import ToolsTeaser from "@/components/home/ToolsTeaser";
import CoFoundTeaser from "@/components/home/CoFoundTeaser";
import Newsletter from "@/components/home/Newsletter";
import HomeFooter from "@/components/home/HomeFooter";
import FounderToolkitQuiz from "@/components/FounderToolkitQuiz";
import { useToolkitQuiz } from "@/hooks/useToolkitQuiz";

const Home = () => {
  const { open, close } = useToolkitQuiz();
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Co-Found with AI — The Founder Toolkit"
        description="Build your startup solo with 80+ AI prompts for validation, building, and scaling — no team or budget needed. The AI founder toolkit."
        path="/"
      />
      <Navbar />
      <HomeHero />
      <HomeStats />
      <AnyaStory />
      <HowItWorks />
      <ToolsTeaser />
      <CoFoundTeaser />
      <Newsletter />
      <HomeFooter />
      <FounderToolkitQuiz open={open} onClose={close} />
    </div>
  );
};

export default Home;
